import Vue from "vue";
import App from "./App.vue";
import { previewFiles, closeFilePreview } from "@/utils/filePreview";

Vue.prototype.$previewFiles = previewFiles;

import store from "./store";
import { installStaticI18n } from "@/i18n";
import { devSyncMessageKey } from "@/i18n/common/index";
import { priceChannelFlags } from "@/services/price-channel/feature-flags";

// 导入vConsole调试工具
// import VConsole from 'vconsole';
// // 只在非生产环境使用vConsole
// if (process.env.NODE_ENV !== 'production') {
//   new VConsole();
// }

// 🔍 导入参数监控器
import parameterMonitor, { recordRender } from "@/utils/parameterMonitor";

// 引入第三方插件
import Vant from "vant";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/zh-CN";
import "element-ui/lib/theme-chalk/index.css";
import "vant/lib/index.css";
import "@/styles/zone.vant.less";
import "@/styles/zone.element.less";
import "@/css/common.css";
import "@/css/common-pc.css";
import "@/styles/common.less";
import "@/styles/mobile-i18n.less";
import "@/styles/pc-contract-i18n.less";
import "@/styles/fixed-ui-i18n.less";
// 竞标频道复用原型的统一设计令牌与 Element 组件规范，避免各页面自行覆盖后产生视觉偏差。
import "@/styles/bid-design-system.scss";
// 1. 先安装设备检测插件
// 引入设备检测Mixin
import DeviceDetect from "@/plugins/device-detect";
import PublishFormComponents from "@/components/publish-form";
import { formatTime } from "./utils/formatTime";
import { formatPrice } from "./utils/price";
import priceInputDirective, {
  focusInvalidPriceInput,
} from "@/directives/priceInput";
import { createPriceRules } from "@/utils/rules";
import {
  checkPriceFields,
  getPriceInputError,
  normalizePriceInput,
} from "@/utils/priceInput";
import $myMessage from "@/utils/message"; // 导入封装的通用消息提示
import { canAccessInternalRemark } from "@/utils/internalRemarkAccess";

Vue.use(DeviceDetect); // 安装插件
// 2. 再导入路由
import router from "./router";
Vue.use(Vant);
Vue.use(PublishFormComponents);
Vue.use(ElementUI, { locale });
installStaticI18n(Vue, store);
Vue.config.productionTip = false;
Vue.prototype.$formatTime = formatTime;
Vue.prototype.$formatPrice = formatPrice;
Vue.directive("price-input", priceInputDirective);
// 价格规则随当前显示语言取提示；不重新加载页面、不改变输入值。
Vue.prototype.$localizePriceError = function (message) {
  const key = devSyncMessageKey(message);
  return key ? this.$t(key) : message;
};
for (const [property, formType] of [
  ["$priceRules", "vant"],
  ["$elementPriceRules", "element"],
]) {
  Object.defineProperty(Vue.prototype, property, {
    get() {
      return createPriceRules({
        formType,
        translate: (message) => this.$localizePriceError(message),
      });
    },
  });
}
Vue.prototype.$priceInputError = function (value, options) {
  return this.$localizePriceError(getPriceInputError(value, options));
};
Vue.prototype.$normalizePriceInput = normalizePriceInput;
Vue.prototype.$checkPriceFields = function (fields) {
  return checkPriceFields(fields, (message) => {
    this.$myMessage.error(this.$localizePriceError(message));
    this.$nextTick(() => {
      if (!focusInvalidPriceInput(this.$el)) focusInvalidPriceInput();
    });
  });
};
Vue.prototype.$myMessage = $myMessage; // 挂载到 Vue 原型上，覆盖 ElementUI 的 $message

// 内部备注只对内部角色开放。全局计算属性让页面和共用弹窗使用同一套口径，
// 且只影响模板渲染，不改变任何原有业务权限和提交数据。
Vue.mixin({
  computed: {
    canAccessInternalRemark() {
      const userState = this.$store && this.$store.state.user;
      return canAccessInternalRemark(
        userState && userState.userDetails,
        userState && userState.userInfo
      );
    },
  },
});

router.beforeEach((to, from, next) => {
  closeFilePreview();
  if (to.meta.title) {
    // document.title = to.meta.title || "";
  }
  next();
  // if (to.path == '/login') {
  //   var isLoginDetails = localStorage.getItem('hm_user_details') ?? {}
  //   var isLoginInfo = localStorage.getItem('hm_shopping_info') ?? {}
  //   let token1 = isLoginDetails ? JSON.parse(isLoginDetails) : {}
  //   let token2 = isLoginInfo ? JSON.parse(isLoginInfo) : {}
  //   if (token1.token && token2.token) {
  //     next('/home')
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
});

// 🔍 SSE数据监控已启动
console.log("🔍 SSE数据监控已启动");

// 百科列表和详情只依赖 xunzhi-kb，不在启动阶段请求商城价格配置或用户详情。
// 收藏等登录操作仍会直接携带本地 Token，由 xunzhi-kb 校验当前用户。
const isWikiPage = /^\/(?:pc\/)?wiki(?:\/|$)/.test(window.location.pathname);
// 独立搜索首页不在启动阶段请求用户详情，避免公开访问被失效登录态打断。
const isStandaloneSearchHome = ["/", "/pc/home", "/pc/autumn-home"].includes(
  window.location.pathname
);
const isPublicFeaturedPage = ["/featured", "/pc/featured"].includes(
  window.location.pathname
);

// 启动时全局请求一次“价格”配置（价格 / 价格单位 / 价格汇率）
// 后台配置变化后，只要项目重新刷新，就会重新请求一次
if (!isWikiPage) {
  store.dispatch("price/loadPriceUnitConfig").then(() => {
    const { priceUnitTree, priceUnitCNY, priceUnitUSD } =
      store.state.price || {};
    console.log("全局价格配置 priceUnitTree:", priceUnitTree);
    console.log("全局价格单位 priceUnitCNY:", priceUnitCNY);
    console.log("全局价格汇率 priceUnitUSD:", priceUnitUSD);
  });
}

// 页面刷新时重新请求用户信息
const userInfo = store.state.user.userInfo;
if (
  !isWikiPage &&
  !isStandaloneSearchHome &&
  !isPublicFeaturedPage &&
  userInfo &&
  userInfo.token
) {
  // 如果存在用户信息和token，则重新获取最新的用户详情
  store
    .dispatch("user/getUserInfo")
    .then(() => {
      console.log("刷新页面时重新获取用户信息成功");
    })
    .catch((error) => {
      console.error("刷新页面时获取用户信息失败:", error);
    });
}

const mountApp = () =>
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");

// 正式入口不装载演示Store/JSON；显式Fixture模式先完成注册与恢复，再启动路由。
if (priceChannelFlags.readSource === "fixture") {
  import(
    /* webpackChunkName: "pricechannel-fixture-bootstrap" */ "@/services/price-channel/fixture-store-entry"
  )
    .then(({ initializeFixtureStore }) => initializeFixtureStore(store))
    .then(mountApp)
    .catch(() => console.error("价格频道演示工作区初始化失败，未切换读取源。"));
} else {
  mountApp();
}
